<template>
    <b-container>
      <b-row class="mt-2">
        <b-col md="8" offset-md="2">
            <b-row class="mb-2">
                <b-col md="5" >
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                        <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''"  size="sm">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>

                </b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>
            <b-table show-empty head-variant="dark"
                stacked="md"
                bordered
                striped
                :items="applications"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                style="font-size:12px"
                @filtered="onFiltered"
            >
                <template slot="actions" slot-scope="row">
                    <b-button :disabled="row.item.ApplicationStatus!='Documents Rejected'" variant="link" size="sm" @click.stop="editApplication(row.item, row.index, $event.target)"
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="Edit Application">
                        <i class="fa fa-pencil-alt" style="font-size:16px;color:blue"></i>
                    </b-button>

                    <b-button variant="link" size="sm" @click.stop="viewApplication(row.item, row.index, $event.target)"
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="View Application">
                        <i class="fa fa-eye" style="font-size:16px;color:green"></i>
                    </b-button>

                    <b-button :disabled="row.item.ApplicationStatus!='Applied'" variant="link" size="sm" @click.stop="viewApplication(row.item, row.index, $event.target)"
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="Remove Application">
                        <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col md="8" class="my-1">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"  size="sm"/>
                </b-col>
                <b-col md="4" class="my-1">
                    <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
                    <b-form-select :options="pageOptions" v-model="perPage"  size="sm" />
                    </b-form-group>
                </b-col>
            </b-row>

        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import apis from "@/apis";
export default {
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  data() {
    return {
      applications: [],
      fields: [
        { key: "BoardName", label: "Board Name", sort: true },
        { key: "ExemptionApplicationNo", label: "Application No.", sort: true },
        { key: "TotalEmployers", label: "Total Employers", sort: true },
        { key: "TotalGuards", label: "Total Guards" },
        { key: "ApplicationStatus", label: "Status" },
        { key: "actions", label: "-" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewApplication(item,index,target){
        this.$router.push({name: 'ViewExemptApplication',params:{"applicationId": item.ExemptionApplicationID}});
        /*Don't use path in the push when usign props*/
    },
    editApplication(item,index,target){
      // alert(item.ExemptionApplicationID)
        this.$router.push({name: 'EditApplication',params:{"applicationId": item.ExemptionApplicationID,'ApplicationDetails':item.ApplicationDetails,'ApplicationStatus':item.ApplicationStatus}});
        /*Don't use path in the push when usign props*/
    },
    getApplicationList() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.GetPendingExemptions(userinfo.UserId);

      promise
        .then(response => {
          if (response.status == 200) {
            this.applications = response.body;
            this.totalRows = this.guards.length;
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted(){
    this.getApplicationList();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ApplyForExemption/PendingApplication.vue